import React from 'react'
import './win.scss';

const Win = () => {
  return (
    <>
      <section className='Win_main'  id='whywewin'>
        <img src='\assets\shade.png' className='shade_img' />
        <div className='custom-container'>
          <div className='inner_scale'>
            <h2>Why We Win</h2>
            <div className='four_types'>
              <div className='left_one'>
                <h3>Feature / Benefit</h3>
                <div className='innner_side'>
                  <h4>Diversified Risk Management</h4>
                  <h4>Focus on Revenue-Generating Assets</h4>
                  <h4>Resilience in Bull, Bear & Sideway</h4>
                  <h4>Targeted High-Growth Opportunities</h4>
                  <h4>Reduced Impact from Single Asset Crash</h4>
                  <h4>Active, Adaptive Allocation</h4>
                  <h4>Exposure to Early-Stage Innovator</h4>
                </div>

              </div>
              <div className='left_two'>
                <h5>MRKTS Strategy</h5>
                <div className='innner_anoter'>
                  <div className='blue_side'>
                    <img src='\assets\tick.svg' />
                  </div>
                  <div className='blue_side'>
                    <img src='\assets\tick.svg' />
                  </div>
                  <div className='blue_side'>
                    <img src='\assets\tick.svg' />
                  </div>
                  <div className='blue_side'>
                    <img src='\assets\tick.svg' />
                  </div>
                  <div className='blue_side'>
                    <img src='\assets\tick.svg' />
                  </div>
                  <div className='blue_side'>
                    <img src='\assets\tick.svg' />
                  </div>
                  <div className='blue_side'>
                    <img src='\assets\tick.svg' />
                  </div>
                </div>

              </div>
              <div className='left_one side_nwww'>
                <h3>Feature / Benefit</h3>
                <div className='innner_side'>
                  <h4>Diversified Risk Management</h4>
                  <h4>Focus on Revenue-Generating Assets</h4>
                  <h4>Resilience in Bull, Bear & Sideway</h4>
                  <h4>Targeted High-Growth Opportunities</h4>
                  <h4>Reduced Impact from Single Asset Crash</h4>
                  <h4>Active, Adaptive Allocation</h4>
                  <h4>Exposure to Early-Stage Innovator</h4>
                </div>

              </div>
              <div className='left_three'>
                <h6>Single Token</h6>
                <div className='innner_new'>
                  <div className='red_side'>
                    <img src='\assets\crosss.svg' />
                  </div>
                  <div className='red_side'>
                    <img src='\assets\crosss.svg' />
                  </div>
                  <div className='red_side'>
                    <img src='\assets\crosss.svg' />
                  </div>
                  <div className='red_side'>
                    <img src='\assets\crosss.svg' />
                  </div>
                  <div className='red_side'>
                    <img src='\assets\crosss.svg' />
                  </div>
                  <div className='red_side'>
                    <img src='\assets\crosss.svg' />
                  </div>
                  <div className='red_side'>
                    <img src='\assets\crosss.svg' />
                  </div>
                </div>

              </div>
              <div className='left_one side_nwww'>
                <h3>Feature / Benefit</h3>
                <div className='innner_side'>
                  <h4>Diversified Risk Management</h4>
                  <h4>Focus on Revenue-Generating Assets</h4>
                  <h4>Resilience in Bull, Bear & Sideway</h4>
                  <h4>Targeted High-Growth Opportunities</h4>
                  <h4>Reduced Impact from Single Asset Crash</h4>
                  <h4>Active, Adaptive Allocation</h4>
                  <h4>Exposure to Early-Stage Innovator</h4>
                </div>

              </div>
              <div className='left_three'>
                <h6>Broad Index Fund</h6>
                <div className='innner_new'>
                  <div className='red_side'>
                    <img src='\assets\tick.svg' />
                  </div>
                  <div className='red_side'>
                    <img src='\assets\crosss.svg' />
                  </div>
                  <div className='red_side'>
                    <img src='\assets\crosss.svg' />
                  </div>
                  <div className='red_side'>
                    <img src='\assets\crosss.svg' />
                  </div>
                  <div className='red_side'>
                    <img src='\assets\tick.svg' />
                  </div>
                  <div className='red_side'>
                    <img src='\assets\crosss.svg' />
                  </div>
                  <div className='red_side'>
                    <img src='\assets\crosss.svg' />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>
    </>
  )
}

export default Win
